function TextBanner() {
    $PrevSelectedDesktop = $("#AnoncementArea ul.desktopSlide li.selectedBannerDesktop")
    $PrevSelectedDesktop.removeClass("selectedBannerDesktop")

    if ($("#AnoncementArea ul.desktopSlide li").length != $PrevSelectedDesktop.index() + 1) {
        $PrevSelectedDesktop.next().addClass("selectedBannerDesktop");
    } else {
        $("#AnoncementArea ul.desktopSlide li").first().addClass("selectedBannerDesktop");
    }

    $PrevSelectedMobile = $("#AnoncementArea ul.mobileSlide li.selectedBannerMobile")
    $PrevSelectedMobile.removeClass("selectedBannerMobile")

    if ($("#AnoncementArea ul.mobileSlide li").length != $PrevSelectedMobile.index() + 1) {
        $PrevSelectedMobile.next().addClass("selectedBannerMobile");
    } else {
        $("#AnoncementArea ul.mobileSlide li").first().addClass("selectedBannerMobile");
    }
}

function settingTextBanner() {
    setInterval(TextBanner, 7000);
}

function GetLayoutTextBanners() {
    $.ajax({
        type: 'get',
        async: true,
        cache: false,
        url: getRequestRoute() + "/p/Home/GetTextBannerList" + getLandingParameter(),
        success: function (dt) {
            if (dt.length > 0) {
                var desktopCounter = 0;
                var mobileCounter = 0;
                for (var i = 0; i < dt.length; i++) {
                    if (dt[i].Area == 12) {
                        if (desktopCounter == 0) {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm selectedBannerDesktop'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        } else {
                            $("#AnoncementArea ul.desktopSlide").append("<li class='hidden-xs hidden-sm'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            desktopCounter++;
                        }
                    } else {
                        if (mobileCounter == 0) {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md selectedBannerMobile'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        } else {
                            $("#AnoncementArea ul.mobileSlide").append("<li class='hidden-lg hidden-md'><a href='" + dt[i].Link + "'>" + dt[i].Content + "</a></li>");
                            mobileCounter++;
                        }
                    }
                }
            }

            settingTextBanner();
        }
    });
}

$(document).ready(function () {
    //settingTextBanner();
    //GetLayoutTextBanners();
    ContentPageProducts();

    if (!isMobileResolution()) {
        $("#HomeBannerSection .SBanner").each(function (index) {
            if ($(this).find(".mobile-section").length > 0) {
                caruselInner = $(this).find(".mobile-section").closest(".carousel-inner");
                caruselInner.find(".carousel-item").first().addClass("active");
            }
        });
    }
    else {
        $("#HomeBannerSection .SBanner").each(function (index) {
            if ($(this).find(".desktop-section").length > 0) {
                caruselInner = $(this).find(".desktop-section").closest(".carousel-inner");
                caruselInner.find(".carousel-item").first().addClass("active");
            }
        });

        $('.bottomMenu p').click(function () {
            $(this).parent().toggleClass("open");
        });
    }

    if ($("body.home .HomeProducts .ProductList .Prd").length > 0) {
        $(".ProductList").slick({
            infinite: true,
            centerMode: true,
            arrows: false,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            centerPadding: '0',
            //variableWidth: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '0',
                        centerMode: false,
                        variableWidth: false
                    }
                }
            ]
        });

        QuickLook();
    }
});

function ContentPageProducts() {
    if ($(".content-main .LandingProducts").length > 0) {

        $(".content-main .LandingProducts").each(function (index) {
            var thisElement = $(this);
            var catalogID = thisElement.attr("data-id");
            var count = thisElement.attr("data-count");

            $.ajax({
                type: 'POST',
                async: true,
                cache: false,
                beforeSend: function () {
                    GenerateLocalLoading(thisElement, "show");
                },
                data: "CatalogID=" + catalogID + "&ProductCount=" + count,
                url: getRequestRoute() + "/p/ContentPg/GetContentProduct" + getLandingParameter(),
                success: function (dt) {
                    thisElement.html(dt);

                    thisElement.find(".ProductList").slick({
                        infinite: true,
                        centerMode: true,
                        arrows: false,
                        dots: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        lazyLoad: 'ondemand',
                        centerPadding: '0',
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    centerPadding: '0',
                                    centerMode: false,
                                    variableWidth: false
                                }
                            }
                        ]
                    });
                },
                error: function () {
                    thisElement.closest(".full-block").remove();
                },
                complete: function () {
                    GenerateLocalLoading(thisElement, "hide");
                }
            });
        });

        LazyLoad();
        QuickLook();
    }
}

$(window).load(function () {
    $(".UseLazyLoad").Lazy();
});